(() => {
  if (window.top !== window.self || window.osCartInstalled) return;
  window.osCartInstalled = true;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false, allowed = null;
  const cartURL = root + 'cart';
  const message = text => {
    let box = document.querySelector('[data-os-cart-message]');
    if (!box) { box = document.createElement('p'); box.setAttribute('role', 'alert'); box.className = 'os-cart-status'; document.querySelector('#t4s-mini_cart .t4s-drawer__bottom, main')?.prepend(box); }
    if (box) { box.textContent = text; box.tabIndex = -1; box.focus(); }
  };
  const lock = value => { busy = value; document.documentElement.classList.toggle('os-cart-busy', value); };
  async function request(url, body) {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...(body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {}) });
    if (!response.ok) throw new Error('The cart could not be updated. Please refresh and try again.');
    return response.json();
  }
  const getCart = () => request(cartURL + '.js');
  const validArtwork = value => typeof value === 'string' && /^(https?:\/\/|\/\/|\/)/.test(value);

  // Keep the original line until Shopify has stored the file on its replacement.
  // The private marker allows safe recovery after a reload or failed response.
  async function reconcile() {
    let cart = await getCart();
    for (const replacement of cart.items.filter(i => i.properties?._os_replace_key)) {
      if (!validArtwork(replacement.properties['Logo artwork'])) throw new Error('Your artwork has not finished saving. Please contact support before checking out.');
      const original = cart.items.find(i => i.key === replacement.properties._os_replace_key);
      if (original) {
        if (original.variant_id !== replacement.variant_id || original.quantity !== replacement.quantity || String(original.quantity) !== replacement.properties._os_replace_qty) throw new Error('Your cart changed during the upload. Please review the items or contact support before checking out.');
        cart = await request(cartURL + '/change.js', { id: original.key, quantity: 0 });
      }
      const current = cart.items.find(i => i.properties?._os_upload_token === replacement.properties._os_upload_token);
      if (!current) throw new Error('Please refresh your cart to check your saved artwork.');
      const properties = {...current.properties};
      delete properties._os_replace_key; delete properties._os_replace_qty; delete properties._os_upload_token;
      cart = await request(cartURL + '/change.js', {id:current.key,quantity:current.quantity,properties});
    }
    return cart;
  }

  async function needsArtwork() {
    const sections = await request(cartURL + '?sections=os-cart-artwork');
    const html = sections['os-cart-artwork'];
    if (!html) throw new Error('Unable to check artwork. Please open your cart and try again.');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const state = doc.querySelector('[data-os-missing]');
    if (!state) throw new Error('Unable to check artwork. Please open your cart and try again.');
    return state.dataset.osMissing === 'true';
  }

  function checkoutTarget(target) { return target.closest?.('[name="checkout"], a[href*="/checkout"], .t4s-btn__checkout'); }
  async function gate(button) {
    if (busy) return;
    const form = button.form;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true' || button.closest('.t4s-pe-none')) return;
    if (form && !form.reportValidity()) return;
    lock(true);
    try {
      if (await needsArtwork()) {
        if (document.querySelector('[data-os-cart-artwork]')) { message('Please save artwork for every custom stamp before checkout.'); document.querySelector('[data-os-cart-artwork]').scrollIntoView({behavior:'smooth'}); }
        else location.assign(cartURL + '#OsCartArtwork');
        return;
      }
      // Replay the original action so Kalles retains its terms and discount handling.
      lock(false); allowed = button; button.click(); setTimeout(() => { allowed = null; }, 0);
    } catch (e) { message(e.message); }
    finally { lock(false); }
  }
  window.addEventListener('click', e => {
    const button = checkoutTarget(e.target);
    if (!button || button === allowed || button.matches('[data-stamp-checkout]')) return;
    e.preventDefault(); e.stopImmediatePropagation(); gate(button);
  }, true);
  window.addEventListener('submit', e => {
    if (!e.target.matches('form') || e.target.matches('[data-stamp-form="true"]')) return;
    const button = e.submitter || e.target.querySelector('[name="checkout"]');
    if (!button || button === allowed || (e.submitter && e.submitter.name !== 'checkout')) return;
    e.preventDefault(); e.stopImmediatePropagation(); gate(button);
  }, true);
  document.addEventListener('change', e => {
    if (e.target.matches('[data-os-cart-file]')) e.target.closest('.os-artwork-row').querySelector('[data-os-file-name]').textContent = e.target.files[0]?.name || 'No file chosen';
  });
  document.addEventListener('click', async e => {
    const button = e.target.closest('[data-os-upload]');
    if (!button || busy) return;
    const row = button.closest('.os-artwork-row'), input = row.querySelector('[data-os-cart-file]'), file = input.files[0];
    const status = row.querySelector('[data-os-upload-message]');
    if (!file || !/\.(png|jpe?g|pdf)$/i.test(file.name) || file.size < 1 || file.size > 10485760) { status.textContent = 'Choose a PNG, JPG or PDF file up to 10 MB.'; return; }
    lock(true); button.disabled = true; status.textContent = 'Saving your artwork. Please keep this page open.';
    let frame, form;
    try {
      const cart = await getCart();
      if (cart.items.some(i => i.properties?._os_replace_key)) { await reconcile(); location.reload(); return; }
      const item = cart.items.find(i => i.key === row.dataset.osLine);
      if (!item) throw new Error('This item changed. Please refresh the cart before uploading.');
      const token = crypto.randomUUID();
      frame = document.createElement('iframe'); frame.name = 'os-upload-' + token; frame.hidden = true; document.body.append(frame);
      form = document.createElement('form'); form.method = 'post'; form.action = root + 'cart/add'; form.enctype = 'multipart/form-data'; form.target = frame.name; form.hidden = true;
      const add = (name,value) => { const f=document.createElement('input'); f.type='hidden';f.name=name;f.value=String(value);form.append(f); };
      add('id',item.variant_id);add('quantity',item.quantity);add('return_to',cartURL);
      if (item.selling_plan_allocation) add('selling_plan',item.selling_plan_allocation.selling_plan.id);
      for (const [k,v] of Object.entries(item.properties||{})) if(k!=='Logo artwork' && k!=='_ownerstamps_artwork_required') add('properties['+k+']',v);
      add('properties[_ownerstamps_artwork_required]','true');add('properties[_os_replace_key]',item.key);add('properties[_os_replace_qty]',item.quantity);add('properties[_os_upload_token]',token);
      const placeholder=document.createComment('upload-input');input.replaceWith(placeholder);input.name='properties[Logo artwork]';form.append(input);document.body.append(form);
      try {
        await new Promise((resolve,reject)=>{
          let finished=false;
          const timer=setTimeout(()=>{finished=true;reject(new Error('Upload took too long. Refresh your cart to check whether it saved before trying again.'));},90000);
          frame.addEventListener('load',async()=>{
            if(finished)return;
            try {
              // Ignore the iframe's initial blank document.
              if(frame.contentWindow.location.href==='about:blank')return;
              const updated=await getCart();const saved=updated.items.find(i=>i.properties?._os_upload_token===token);
              if(!saved||!validArtwork(saved.properties['Logo artwork']))throw new Error('Shopify could not save this upload. Your original item is still in the cart. Please try again or contact support.');
              finished=true;clearTimeout(timer);resolve();
            }catch(error){finished=true;clearTimeout(timer);reject(error);}
          });
          HTMLFormElement.prototype.submit.call(form);
        });
        await reconcile(); location.reload();
      } finally { input.removeAttribute('name');placeholder.replaceWith(input); }
    } catch(error) { status.textContent=error.message; }
    finally {form?.remove();frame?.remove();button.disabled=false;lock(false);}
  });
  if (document.querySelector('[data-os-cart-artwork]')) {
    lock(true);
    getCart().then(async cart => {if(cart.items.some(i=>i.properties?._os_replace_key)){await reconcile();location.reload();}}).catch(e=>message(e.message)).finally(()=>lock(false));
  }
})();
